module.exports = __webpack_public_path__ + "img/chain14.9f6d47e1.png";